<template>
  <article>
    <section
      class="mx-auto my-16 mb-12 grid grid-flow-col border-b border-[#d9d5d5] pb-16 sm:my-4 sm:flex sm:flex-col sm:gap-5 sm:pb-4 md:max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-xl"
    >
      <EditableArea
        v-if="column"
        :class="{ 'grid auto-cols-fr grid-flow-row justify-between md:grid-flow-col mobile:px-4': column?.nodes?.length }"
        :content="column"
      />
    </section>
    <section class="mx-auto flex flex-col sm:my-4 md:max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-xl">
      <EditableArea
        v-if="brands"
        class="mb-4"
        :content="brands"
      />
      <section
        v-if="showFootnote"
        class="pb-2 text-[13px] text-[#595959]"
      >
        <p><sup>1</sup>{{ $t("Lowest total price in the last 30 days before the discount") }}</p>
      </section>
    </section>
    <LegalInformation :links="links" />
    <!-- Text to show staging version -->
    <div v-if="$config.public.appEnvironment === 'test' || $config.public.appEnvironment === 'stage'">
      Version: {{ $config.public.appVersion }}
    </div>
  </article>
</template>

<script lang="ts" setup>
import { EditableArea } from '@magnolia/vue-editor/dist/vue-editor.es.js';
import LegalInformation from './Partials/LegalInformation.vue';
import { usePageLoader } from '~/composables/custom/usePageLoader/usePageLoader';

interface Props {
  links?: any[];
  column?: any;
  brands?: any;
}

withDefaults(defineProps<Props>(), {
  links: () => [],
  column: undefined,
  brands: undefined,
});

const route = useRoute();
const { content } = usePageLoader('footer-root');
const showFootnote = computed(() => (['category', 'product'].includes(route.name as string) ? true : (content.value?.showFootnote ?? false)));
</script>
